// extracted by mini-css-extract-plugin
export default {"card":"Tile_card__8t9Hm","cta":"Tile_cta__KWYm3","ctaWrapper":"Tile_ctaWrapper__QcNz5"};